import { api } from './configs/axiosConfig';

const endPoint = "/item";

export const itemAPI = {
    getItems: async function (pCode, searchKey) {
        const reponse = await api.request({
            url: endPoint,
            method: 'GET',
            params: { pCode, searchKey }
        });

        return reponse.data;
    }
}